import clsx from "clsx";
import React, { forwardRef } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { HeaderMenuItemCloseButton } from "../header-menu-item-close-button";
import { tabColorScheme } from "./styles";
import { HeaderMenuItemTabColorScheme } from "./types";

export interface HeaderMenuItemTabsProps {
  className?: string;
}

export const HeaderMenuItemTabs = forwardRef<HTMLDivElement, HeaderMenuItemTabsProps>(
  ({ className }, ref) => {
    const { expandedEditorialItem, expandedTabId, setExpandedTabId } = useHeaderMenu();
    const isOnlyTab = expandedEditorialItem && (expandedEditorialItem?.tabs?.length ?? 0) === 1;
    if (isOnlyTab) return null;
    return (
      <div
        ref={ref}
        className={clsx(
          "bg-neutral block px-4 pb-4 relative rounded-b-4xl",
          "flex justify-center items-center gap-6",
          className
        )}
      >
        <div className="absolute right-8 top-2">
          <HeaderMenuItemCloseButton />
        </div>
        {expandedEditorialItem?.tabs?.map((tab, i) => {
          if (!tab?.colorScheme) return null;
          return (
            <button
              type="button"
              className={clsx(
                "py-2 px-4 rounded-lg font-bold transition-all duration-300",
                expandedTabId === tab.id &&
                  tabColorScheme[tab.colorScheme as HeaderMenuItemTabColorScheme]
              )}
              key={i}
              onClick={() => setExpandedTabId(tab.id)}
            >
              {tab.tabLabel}
            </button>
          );
        })}
      </div>
    );
  }
);
